import { CartUpdatedEvent } from '@theme/events';

// Toggle « Protection colis » : ajoute ou retire le produit de protection du panier.
// Le rendu (état coché, ligne masquée dans la liste) est serveur-side : après chaque
// opération on redéclenche le rendu du drawer via CartUpdatedEvent, comme les steppers.
class CartProtection extends HTMLElement {
  constructor() {
    super();
    this.toggleHandler = this.#handleToggle.bind(this);
  }

  connectedCallback() {
    this.input = this.querySelector('[data-ref="protection-toggle"]');
    this.input?.addEventListener('change', this.toggleHandler);
  }

  disconnectedCallback() {
    this.input?.removeEventListener('change', this.toggleHandler);
  }

  async #handleToggle() {
    if (!this.input) return;

    this.classList.add('cart-protection--loading');
    this.input.disabled = true;

    const sectionId = this.closest('cart-drawer')?.dataset.sectionId;
    const sections = [sectionId, 'auto-gifts'].filter(Boolean).join(',');

    try {
      let response;

      if (this.input.checked) {
        response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: Number(this.dataset.variantId),
                quantity: 1,
                properties: { _protection: 'true' },
              },
            ],
            sections,
            sections_url: window.location.pathname,
          }),
        });
      } else {
        if (!this.dataset.lineKey) return;

        response = await fetch(Theme.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: this.dataset.lineKey,
            quantity: 0,
            sections,
            sections_url: window.location.pathname,
          }),
        });
      }

      const data = await response.json();

      if (data.errors || data.status >= 400) {
        this.input.checked = !this.input.checked;
        const message = typeof data.errors === 'string' ? data.errors : data.message || 'Erreur panier';
        document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message } }));
        return;
      }

      document.dispatchEvent(
        new CartUpdatedEvent(
          {},
          {
            itemCount: data.item_count,
            source: 'cart-protection',
            sections: data.sections,
          },
        ),
      );
    } catch (error) {
      console.error('CartProtection: toggle failed', error);
      this.input.checked = !this.input.checked;
    } finally {
      this.input.disabled = false;
      this.classList.remove('cart-protection--loading');
    }
  }
}

if (!customElements.get('cart-protection')) {
  customElements.define('cart-protection', CartProtection);
}
